export default "__VITE_ASSET__DkSHPYo0__"